// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1583) return "static/chunks/1583-10578c54a873def2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7012":"7f49527441d590e5","8320":"0c63beae00a42079"}[chunkId] + ".js";
};